/* mixins/userSettings */
import { mapActions, mapGetters } from 'vuex'

import FormMixin from '@/mixins/form'

const cookieKey = 'MyMaxCareRxUserSettings'

export default {
    mixins: [
        FormMixin
    ],

    computed: {
        ...mapGetters([
            'getDarkMode',
            'getDisplayName',
            'getExpandTree',
            'getStickySidebar',
            'getUserId',
            'getUserSettings'
        ])
    },

    methods: {
        ...mapActions([
            'setDarkMode',
            'setExpandTree',
            'setStickySidebar',
            'setUser',
            'setUserSettings'
        ]),

        retrieveUserSettings() {
            return this.$cookies.get(cookieKey)
        },

        persistUserSettings() {
            this.$cookies.set(cookieKey, this.getFormData(this.getUserSettings), new Date(2031, 1, 1))
        }
    }
}